import React from 'react'
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
const BooleanInput = ({value, onBlur, name}) =>
    <RadioGroup
        row aria-label="position"
        name={name}
        onClick={onBlur}
        value={value}
        id={`MEDCAL_RX_RADIO_BOOLEAN_${Math.floor(Math.random()*(50000-2 +1) + 2)}`}
        data-testid='MEDCAL_RX_RADIO_BOOLEAN'
    >
        <FormControlLabel
            value="yes"
            control={<Radio color="primary" inputProps={{'data-testid': `${name}_RADIO_TRUE`, 'id': `${name}_RADIO_TRUE` }} />}
            label="Yes"
            labelPlacement="end"
        />
        <FormControlLabel
            value="no"
            control={<Radio color="primary" inputProps={{'data-testid': `${name}_RADIO_FALSE`, 'id': `${name}_RADIO_FALSE` }} />}
            label="No"
            labelPlacement="end"
        />
    </RadioGroup>

export default BooleanInput;